import React from 'react';

const BlockIcon = ({ icon, outlined }) => (
    <span className={`ch-lesson-plan-section-icon${outlined ? ' ch-lesson-plan-section-icon--outlined' : ''}`}>{icon}</span>
);

export default BlockIcon;
